<template>
  <section class="hero is-fullheight is-light is-bold">
    <div class="hero-body">
      <div class="container has-text-centered">
        <div class="column is-10 is-offset-1">
          <h1 class="title">
            <span>The American English Dialect Survey</span>
          </h1>
          <h2 class="subtitle">
            Thank you for taking the Dialects of American English Survey! Your answers help our heat maps get better. Stay tuned for new surveys, quizzes and games!
          </h2>
        </div>

        <social-media></social-media>
      </div>
    </div>
  </section>
</template>

<script>
import SocialMedia from './SocialMedia';

export default {
  components: {
    SocialMedia,
  }
};
</script>

<style>
.hero .subtitle {
  padding: 3rem 0;
  line-height: 1.5;
}
</style>



// WEBPACK FOOTER //
// src/components/Thanks.vue